import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import RevolutDisclaimer from './RevolutDisclaimer';
export const REVOLUT_WITH_DISCLAIMER = {
    alias: 'revolut',
    disclaimer: _jsx(RevolutDisclaimer, {}),
    comparisonTableFooterDisclaimer: (_jsx("div", Object.assign({ "data-testid": "revolut-comparison-table-footer-disclaimer" }, { children: _jsx(FormattedMessage, { id: "revolut-comparison-table-footer-disclaimer" }) }))),
};
